import { Button } from "./Elements"; 
import {Modal} from "./";






const KvkkModal =({isOpenKvkkModal, setIsOpenKvkkModal, firmKvkkText})=>{


    return(
        <Modal openModal={isOpenKvkkModal} setOpenModal={setIsOpenKvkkModal}
        dialogclass={"!max-w-[1000px]"}
      >
        <div dangerouslySetInnerHTML={{
          __html: firmKvkkText
        }}>
        </div>
        <div className="mt-5 sm:mt-4 sm:flex sm:justify-end space-x-2">
          <Button
            color="primary"
            hover="primary"
            size="xs"
            callback={() => setIsOpenKvkkModal(false)}
          >
            Kapat
          </Button>
        </div>
      </Modal>
    );
}
export default KvkkModal;